import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import { FadeUp } from "@/components/Motion";
import SeoHead from "@/components/SeoHead";

export default function NotFound() {
  return (
    <>
      <SeoHead title="Page not found | PIRAC" description="The page you are looking for is not available." noindex />
      <section className="min-h-[70vh] flex items-center bg-[#060f1e] py-24">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 w-full">
          <div className="watermark-num select-none">404</div>
          <FadeUp>
            <h1 className="mt-8 font-serif text-5xl md:text-7xl text-[#f7f5f0] font-light tracking-tight leading-[0.98]">
              This page is off-market.
            </h1>
            <p className="mt-6 text-[#d8d8d8] max-w-xl leading-relaxed">The address you were looking for does not exist, or has been moved. Return to the home page and start fresh.</p>
            <div className="mt-10 flex gap-4">
              <Link to="/" data-testid="notfound-home" className="inline-flex items-center gap-3 px-6 h-12 bg-[#cca24d] text-[#060f1e] text-sm">Return home</Link>
              <Link to="/contact" className="inline-flex items-center gap-3 px-6 h-12 border border-[#1a2940] text-[#f7f5f0] text-sm hover:border-[#cca24d] hover:text-[#cca24d] transition-colors">Contact PIRAC</Link>
            </div>
          </FadeUp>
        </div>
      </section>
    </>
  );
}
